import Ambitus from 'src/modules/ambitus/Ambitus';
import UserConfigurations from "./UserConfigurations";
import {analyticsController} from "../analytics/AnalyticsController";
import UserActivity from "./UserActivity";
import {TrialDurationInMiliseconds} from "./TrialData"
import {levels} from 'src/modules/user/models/UserLevelsData';

export default class User {
  id: number = 0;
  firstname: string = '';
  email: string = '';
  lastname: string = '';

  level: any = {
    value: 1,
    name: "Novice",
    catalog_difficulty: 1
  };

  ambitus: Ambitus = {high: -1, low: -1};
  configurations: UserConfigurations = new UserConfigurations();
  handSize: any = {left: null, right: null}

  premium: boolean = false;
  currentPlan: string|any = 'free';
  subscribedAt: Date = new Date();
  trialEndsAt: number|null = null;
  emailVerifiedAt: Date|null = null;

  newsletterConsent: boolean = true;
  notificationsConsent: boolean = true;

  createdFrom: string = '';
  status: string = '';
  isConnectedWithExternalProvider: boolean = false;

  userActivityData: UserActivity = new UserActivity()

  paymentGroupTesting: 'A' | 'B' | 'C' | null = null
  isInPaymentGroupAorB: boolean = false

  importedPieceIds: number[] = []

  get trialStartAt() {
    if(this.trialEndsAt) {
      return new Date(this.trialEndsAt - TrialDurationInMiliseconds)
    }

    return null
  }
  get isAdmin() {
    return this.configurations.teamMember === 'admin'
  }
  get trialAvailable() {
    return !this.premium && this.status !== 'TRIAL_ENDED' && this.trialEndsAt === null
  }
  get readableTrialEndsAt() {
    if (this.trialEndsAt === null) {
      return 'N/A';
    }
    return Intl.DateTimeFormat('fr-FR', { month: "long", day: 'numeric'}).format(this.trialEndsAt);
  }

  get hasAccessHiddenCatalog() {
    // TODO: clean up this
    return this.currentPlan.name === 'Contenu Payant' || this.currentPlan === 'ALPHA_MEMBER' || this.currentPlan === 'BETA_MEMBER' || this.currentPlan === 'EARLY_MEMBER';
  }

  updateDataFromJson(data: any) {
    const {id, firstname, email, lastname, newsletter_consent, notifications_consent, premium, subscribed_at, current_plan, is_connected_with_external_provider, ambitus_low, ambitus_high, trial_ends_at, configurations, created_from, email_verified_at, status, left_hand_size, right_hand_size, level, activity_data, payment_group_testing, is_in_payment_group_a_or_b, imported_piece_ids} = data;

    this.id = id;
    this.firstname = firstname;
    this.lastname = lastname;
    this.email = email;
    this.newsletterConsent = newsletter_consent;
    this.notificationsConsent = notifications_consent;
    this.premium = premium;
    this.subscribedAt = subscribed_at;
    this.trialEndsAt = (trial_ends_at) ? Date.parse(trial_ends_at) : null;
    this.emailVerifiedAt = email_verified_at;
    this.currentPlan = current_plan;
    this.ambitus = {high: ambitus_high, low: ambitus_low};
    if (left_hand_size && right_hand_size) {
      this.handSize = {left: left_hand_size, right: right_hand_size};
    }
    this.createdFrom = created_from;
    this.status = status;
    this.isConnectedWithExternalProvider = is_connected_with_external_provider;
    this.paymentGroupTesting = payment_group_testing
    this.isInPaymentGroupAorB = is_in_payment_group_a_or_b
    this.importedPieceIds = imported_piece_ids

    this.configurations.updateDataFromJson(configurations);
    this.userActivityData.updateDataFromJson(activity_data)



    if (level) {
      this.level = level

      // Temporary disable level 2 while starting to integrate the skill model
      if (this.level.value === 2) {
        this.level = levels[0]
      }
      analyticsController.addAmplitudeIdentityInformation('LEVEL', this.level.name);
    }
    document.documentElement.style.setProperty('--teacher-image', `url(${this.configurations.teacherUrl})`);
  }
}
